let currentAuthToken = '';

export const setAuthToken = (token = '') => {
  currentAuthToken = token;
};

export const getAuthToken = () => currentAuthToken;

export const clearAuthToken = () => {
  currentAuthToken = '';
};